export default __webpack_public_path__ + "static/media/Toy_portfolio.6ae41a62.png";